import { useLanguage } from '@/composition/useLanguage'
import X7lang, { type LangFunction } from '@x7web/x7-lang-vue'

const { defaultLanguage, curLanguage } = useLanguage()

const x7lang = new X7lang({
  lang: unref(curLanguage),
  defaultLang: defaultLanguage,
  functionName: '$t'
})

/**
 * 语言函数
 */
const $t: LangFunction = x7lang.langFun

export default $t
